import { registerBlockType } from '@wordpress/blocks'
import { G, Path, SVG } from '@wordpress/components'
import ServerSideRender from '@wordpress/server-side-render'

registerBlockType('usna1978/classmate-map', {
  title: 'Classmate Map',
  description: 'Shows a map of where classmates are located.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path fill='none' d='M0 0h24v24H0V0z' /><G><Path d='M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' /></G></SVG>,
  category: 'widgets',

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit () {
    return (
      <ServerSideRender
        block='usna1978/classmate-map'
      />
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return null
  }
})
